import { makeAutoObservable } from "mobx";

export default class ProfilPlayer {
    _id;
    _pseudo;
    _score;
    _profilPicture;
    _theme;
    constructor({ id, pseudo, score, profilPicture, theme }) {
        this._id = id;
        this._pseudo = pseudo;
        this._score = score;
        this._profilPicture = profilPicture;
        this._theme = theme;
        makeAutoObservable(this);
    }

    get id() {
        return this._id;
    }

    get pseudo() {
        return this._pseudo;
    }

    get score() {
        return this._score;
    }

    get profilPicture() {
        return this._profilPicture;
    }

    get theme() {
        return this._theme;
    }





    set id(id) {
        this._id = id;
    }

    set pseudo(pseudo) {
        this._pseudo = pseudo;
    }

    set score(score) {
        this._score = new Date(score);
    }

    set profilPicture(profilPicture) {
        this._profilPicture = profilPicture;
    }

    set theme(theme) {
        this._theme = theme;
    }
}

